import { ChangeDetectionStrategy, Component, input, linkedSignal, output } from '@angular/core';
import { Option } from '../../types/option';

@Component({
    selector: 'juyo-typeahead-search',
    styleUrl: 'typeahead-search.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="typeahead">
            <input
                type="text"
                name="search"
                class="typeahead-input"
                [placeholder]="placeholder() ?? ''"
                [value]="inputValue()"
                (input)="onInput($event)"
                (keydown)="onKeydown($event)"
            />
            @if (options().length > 0) {
                <div class="panel">
                    @for (option of options(); track option.key) {
                        <div class="option-item" (click)="onOptionClick(option)"><span class="option-label">{{ option.label }}</span></div>
                    }
                </div>
            }
        </div>
    `,
})
export class TypeaheadSearchComponent {
    public options = input<Option[]>([]);
    public placeholder = input<string>();
    public value = input<string>('');

    public search = output<string>();
    public optionClick = output<Option>();

    protected inputValue = linkedSignal(() => this.value());

    protected onInput(event: Event): void {
        const value = (event.target as HTMLInputElement).value;
        this.inputValue.set(value);
        this.search.emit(value);
    }

    protected onOptionClick(option: Option): void {
        this.inputValue.set(option.label);
        this.optionClick.emit(option);
    }

    protected onKeydown(event: KeyboardEvent): void {
        if (event.key === 'Escape' || event.key === 'Tab') {
            this.inputValue.set('');
            this.search.emit('');
        }
    }
}
